import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-charcoal" data-id="element-47">
      {/* Background Image - Nigerian construction site */}
      <motion.div className="absolute inset-0 z-0" initial={{
      scale: 1.05
    }} animate={{
      scale: 1
    }} transition={{
      duration: 1.2,
      ease: [0.16, 1, 0.3, 1]
    }} data-id="element-48">
        <div className="absolute inset-0 opacity-50" style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1590856029826-c7a73142bbf1?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-49" />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/70 via-charcoal/80 to-charcoal" data-id="element-50" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-white" data-id="element-51">
        <div className="max-w-4xl" data-id="element-52">
          {/* Eyebrow */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mb-8" data-id="element-53">
            <span className="inline-block text-sm font-medium text-gold tracking-wide uppercase" data-id="element-54">
              Est. 2021 • Nigeria
            </span>
          </motion.div>

          {/* Main Headline */}
          <motion.h1 className="font-heading font-semibold text-5xl sm:text-6xl md:text-7xl lg:text-8xl mb-8 leading-[1.1] tracking-tight" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-55">
            <span className="text-white" data-id="element-56">Building Excellence,</span>
            <br data-id="element-57" />
            <span className="text-gold" data-id="element-58">Engineering the Future</span>
          </motion.h1>

          {/* Subheadline */}
          <motion.p className="text-lg sm:text-xl text-white/70 mb-12 max-w-2xl leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-59">
            A multidisciplinary construction and engineering company delivering
            innovative, sustainable, and world-class solutions across Nigeria.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div className="flex flex-col sm:flex-row gap-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} data-id="element-60">
            <Link to="/services" data-id="element-61">
              <motion.button whileHover={{
              backgroundColor: '#D4B896'
            }} whileTap={{
              scale: 0.98
            }} className="group px-8 py-4 bg-gold text-charcoal font-semibold text-[15px] transition-colors flex items-center justify-center gap-2 w-full sm:w-auto" data-id="element-62">
                Explore Services
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" strokeWidth={2} data-id="element-63" />
              </motion.button>
            </Link>

            <Link to="/portfolio" data-id="element-64">
              <motion.button whileHover={{
              backgroundColor: 'rgba(255, 255, 255, 0.15)'
            }} whileTap={{
              scale: 0.98
            }} className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold text-[15px] border border-white/20 transition-colors flex items-center justify-center gap-2 w-full sm:w-auto" data-id="element-65">
                View Portfolio
              </motion.button>
            </Link>
          </motion.div>

          {/* Stats */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="mt-20 grid grid-cols-3 gap-8 max-w-2xl" data-id="element-66">
            {[{
            value: '₦500M+',
            label: 'Projects Delivered'
          }, {
            value: '150+',
            label: 'Completed Projects'
          }, {
            value: '98%',
            label: 'Client Satisfaction'
          }].map((stat, index) => <div key={index} className="border-l border-white/20 pl-4" data-id="element-67">
                <div className="font-heading font-semibold text-2xl text-white mb-1" data-id="element-68">
                  {stat.value}
                </div>
                <div className="text-sm text-white/50" data-id="element-69">{stat.label}</div>
              </div>)}
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10" animate={{
      y: [0, 8, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-70">
        <div className="w-[1px] h-16 bg-gradient-to-b from-white/40 to-transparent" data-id="element-71" />
      </motion.div>
    </section>;
}